module.exports = __webpack_public_path__ + "pattern5.372dee6df561fd2ed153.png";


//////////////////
// WEBPACK FOOTER
// D:/Angular projects/memberreg/memberreg/src/assets/images/pattern5.png
// module id = ../../../../../src/assets/images/pattern5.png
// module chunks = styles